import React from 'react';

import Layout from '~/components/layout';
import { SEO } from '~/components/seo';
import { RecruitMain } from '~/components/recruit_page';
import { Footer } from '~/components/footer';

const RecruitPage: React.FC = () => (
  <Layout>
    <SEO
      title="採用情報"
      description="株式会社Re rootsの採用情報ページです。次のトレンドを創りたい仲間募集。【新卒/中途/インターン】"
    />
    <RecruitMain />
  </Layout>
);

export default RecruitPage;
